// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactSitterForm_root__Dpd5s","notice":"ContactSitterForm_notice__xnqWw"};